export default {
    "api": {
        "baseUrl" : window.Configuration.BASE_URL,
        "version": window.Configuration.VERSION,
    }
}
